import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  AppBar,
  Toolbar,
  IconButton,
  Grid,
  Card,
  CardContent
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslation';

const About = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box>
      <AppBar position="static" sx={{ backgroundColor: 'white', color: 'black', boxShadow: 1 }}>
        <Toolbar>
          <IconButton onClick={() => navigate('/')} sx={{ mr: 2 }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
            {t('about.aboutBookingBarber')}
          </Typography>
        </Toolbar>
      </AppBar>

      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Box textAlign="center" mb={6}>
          <Typography variant="h3" gutterBottom sx={{ fontWeight: 'bold' }}>
            {t('about.aboutBookingBarber')}
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 800, mx: 'auto' }}>
            {t('about.referencePlatform')}
          </Typography>
        </Box>

        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Paper elevation={0} sx={{ p: 4, border: '1px solid #e0e0e0', height: '100%' }}>
              <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
                {t('about.ourMission')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('about.missionDescription1')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('about.missionDescription2')}
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper elevation={0} sx={{ p: 4, border: '1px solid #e0e0e0', height: '100%' }}>
              <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
                {t('about.ourVision')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('about.visionDescription1')}
              </Typography>
              <Typography variant="body1" paragraph>
                {t('about.visionDescription2')}
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        <Box mt={6}>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center', mb: 4 }}>
            {t('about.ourValues')}
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ height: '100%', textAlign: 'center' }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                    {t('about.simplicity')}
                  </Typography>
                  <Typography variant="body2">
                    {t('about.simplicityDesc')}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ height: '100%', textAlign: 'center' }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                    {t('about.innovation')}
                  </Typography>
                  <Typography variant="body2">
                    {t('about.innovationDesc')}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ height: '100%', textAlign: 'center' }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                    {t('about.support')}
                  </Typography>
                  <Typography variant="body2">
                    {t('about.supportDesc')}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ height: '100%', textAlign: 'center' }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                    {t('about.transparency')}
                  </Typography>
                  <Typography variant="body2">
                    {t('about.transparencyDesc')}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>

        <Box mt={6}>
          <Paper elevation={0} sx={{ p: 4, border: '1px solid #e0e0e0', backgroundColor: '#fafafa' }}>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center', mb: 3 }}>
              {t('about.omniversLTD')}
            </Typography>
            <Typography variant="body1" paragraph textAlign="center">
              {t('about.omniversDescription')}
            </Typography>
            <Box textAlign="center">
              <Typography variant="body2" color="text.secondary">
                <strong>{t('about.registeredCompany')}:</strong> {t('about.companyDetails')}<br />
                <strong>{t('about.address')}:</strong> {t('legal.companyAddress')}<br />
                <strong>{t('about.jurisdiction')}:</strong> {t('about.jurisdictionDetails')}
              </Typography>
            </Box>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
};

export default About;